import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { router } from "./routes";
import { applyPersistedTheme } from "./stores/ui";
import "./styles/globals.css";

applyPersistedTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Most lists come from REST + WS deltas — short staleTime is fine.
      staleTime: 5_000,
      retry: (failureCount, err: unknown) => {
        if (typeof err === "object" && err && "status" in err) {
          const status = (err as { status?: number }).status ?? 0;
          if (status >= 400 && status < 500) return false;
        }
        return failureCount < 2;
      },
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </React.StrictMode>,
);
